import { FC } from 'react'
import { Box, Button, Stack } from '@mui/material'
import { useAuthenticationContext } from '../../../auth/AuthenticationContextProvider'
import { WRITE_LOCATION_CHANGE_SCOPE } from '../../../constants'
import MapImage from '../../../assets/images/address_map_bg.png'
import ScheduleNewAddressIcon from '../../../assets/images/address_icons_preset.svg'

interface ScheduleNewAddressPanelProps {
  onScheduleNewAddress?: () => void
}

export const ScheduleNewAddressPanel: FC<ScheduleNewAddressPanelProps> = ({ onScheduleNewAddress }) => {
  const authContext = useAuthenticationContext()
  const userCanAddAddressChange = authContext.has(WRITE_LOCATION_CHANGE_SCOPE)

  const handleScheduleClick = () => {
    if (onScheduleNewAddress) {
      onScheduleNewAddress()
    }
  }

  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: 'var(--border-radius-s)',
        height: '20rem',
        width: '100%',
        border: '1px solid var(--border-medium)',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${MapImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(3.5px)',
          zIndex: 0
        }
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Box>
          <img src={ScheduleNewAddressIcon} alt="icon" />
        </Box>
        <Box>
          <Button
            variant="contained"
            onClick={handleScheduleClick}
            disabled={!userCanAddAddressChange}
            data-testid="new-change-address-button"
            sx={{
              bgcolor: 'var(--button-primary)',
              '&:hover': {
                bgcolor: 'var(--button-primary-pressed)'
              }
            }}
          >
            Schedule a new address
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
